import { EyeFilled, EyeOffFilled } from "@fluentui/react-icons";
import { FC, useState } from "react";
import FormInput, { FormInputProps } from "./FormInput";

// export interface FormPasswordInputProps extends FormInputProps {}

const FormPasswordInput: FC<FormInputProps> = (props) => {
  const [encrypted, setEncrypted] = useState(true);
  return (
    <FormInput
      {...props}
      type={encrypted ? "password" : "text"}
      contentAfter={
        <button type="button" onClick={(e) => setEncrypted((prevState) => !prevState)}>
          {encrypted ? <EyeOffFilled /> : <EyeFilled />}
        </button>
      }
    />
  );
};

export default FormPasswordInput;
